import { InputAdornment } from '@mui/material';
import { type SxProps, type Theme } from '@mui/material/styles';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { TextField } from 'mui-rff';

type ReadOnlyLockedFieldProps = {
  name: string;
  label: string;
  value: string;
  prefix?: string;
  sx?: SxProps<Theme>;
};

export const ReadOnlyLockedField = ({ name, label, value, prefix, sx }: ReadOnlyLockedFieldProps) => (
  <TextField
    disabled
    name={name}
    label={label}
    value={value}
    placeholder="-"
    sx={sx}
    InputProps={{
      startAdornment: prefix ? <InputAdornment position="start">{prefix}</InputAdornment> : undefined,
      endAdornment: (
        <InputAdornment position="end">
          <LockOutlinedIcon fontSize="small" sx={{ opacity: 0.4 }} />
        </InputAdornment>
      )
    }}
  />
);
